import { DeliveryDiscountsService } from '@/core/services/delivery-discounts.service'

import {
    AddUserDiscountPayload,
    DiscountTypePayload,
    GetDiscountTypeResponse,
    GetDiscountTypesParams,
    GetDiscountTypesResponse,
} from '@/core/types/delivery-discounts.types'

const deliveryDiscountsService = new DeliveryDiscountsService()

class DeliveryDiscountsRealisation {
    getDiscountTypes(params: GetDiscountTypesParams): Promise<GetDiscountTypesResponse> {
        return deliveryDiscountsService.getDiscountTypes(params)
    }

    getDiscountType(discount_type_id: number): Promise<GetDiscountTypeResponse> {
        return deliveryDiscountsService.getDiscountType(discount_type_id)
    }

    createDiscountType(payload: DiscountTypePayload): Promise<void> {
        return deliveryDiscountsService.createDiscountType(payload)
    }

    updateDiscountType(discount_type_id: number, payload: DiscountTypePayload): Promise<void> {
        return deliveryDiscountsService.updateDiscountType(discount_type_id, payload)
    }

    addUserDiscount(payload: AddUserDiscountPayload): Promise<void> {
        return deliveryDiscountsService.addUserDiscount(payload)
    }
}

export const deliveryDiscounts = new DeliveryDiscountsRealisation()
